import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Vue from 'vue';
import VueAMap from 'vue-amap'; //注意不要和 AMap原始名称覆盖

Vue.use(VueAMap); // 初始化vue-amap

VueAMap.initAMapApiLoader({
  // 高德的key
  key: '44641f38739649861c9d7d31f69b4ac2',
  // 插件集合
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geolocation'],
  v: '1.4.4'
});
var amapManager = new VueAMap.AMapManager();
import { //   queryinletList,
//   querySewageOutletList,
//   querySiteList,
//   querySiteIdsList,
//   querySewageAoList,
//   queryPipeSystem,
//   querySiteById,
querySiteBySt, mainRealtime as _mainRealtime, querySiteList as _querySiteList, queryDateList, queryBigDataById, queryStand, queryStandardTreeList, queryDateSkylist, querySkyStandBySite //   queryOnlineById,
} from '@/api/api';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import fileTable from '@/components/border/fileTable';
import { getAction } from '@/api/manage'; // 空气质量指数表盘图

import instrument from '@/components/env-bigData/instrument'; // 空气质量指数进度图

import barType from '@/components/env-bigData/barType';
import dial from '@/components/env-bigData/watch'; // 空气质量天数表盘图

import plate from '@/components/env-bigData/plate'; // 空气质量天数双表盘图

import doublePlate from '@/components/env-bigData/doublePlate';
import imgUrl from '@/assets/others/index/bg.gif';
export default {
  components: {
    dial: dial,
    plate: plate,
    doublePlate: doublePlate,
    fileTable: fileTable,
    instrument: instrument,
    barType: barType
  },
  mixins: [GetSiteIdMixin],
  data: function data() {
    var _ref;

    return _ref = {
      standList: [],
      mapSelectindex: 1,
      netSelectindex: 0,
      roadSelectindex: 0,
      mapControlindex: 0,
      showLeft: false,
      markerList: [],
      imgUrl: require('@/assets/others/index/bg.gif'),
      wrongUrl: require('@/assets/others/index/wrong.png'),
      firstPollution: {},
      standardList: [],
      siteDetail: {},
      selectType: 0,
      inletStatus: '',
      outletStatus: '',
      loading: false,
      dataSource: [],
      online: '1',
      amapManager: amapManager,
      zoom: 15,
      center: [118.047928, 24.613341],
      mapStyle: 'amap://styles/dark',
      //设置地图样式
      plugin: [{
        pName: 'MapType',
        defaultType: 1,
        showRoad: false,
        showButton: false,
        showTraffic: false,
        events: {
          init: function init(o) {}
        }
      }],
      lines: [],
      markers: [],
      windows: [],
      window: '',
      // 表头
      columns: [],
      url: {
        list: '/oms/st52/sewage/api/water/latest'
      },
      siteInfo: {},
      imgSrc: '',
      imgSrc2: '',
      showDrawer: false,
      imgSrc3: '',
      imgSrc4: '',
      imgSrc5: '',
      imgSrc6: '',
      dateLists: [],
      standState: false,
      standLabel: '',
      standText: '',
      showState: true
    }, _defineProperty(_ref, "standardList", []), _defineProperty(_ref, "url", {
      imgerver: window._CONFIG['domianURL'] + '/sys/common/file/view'
    }), _ref;
  },
  created: function created() {
    this.zoom = window.localStorage.getItem('mapZoom') ? window.localStorage.getItem('mapZoom') : 12;
    this.getSite();
    this.getStandard();
    this.center = window.localStorage.getItem('mapCenter') && window.localStorage.getItem('mapCenter') != 'null' ? window.localStorage.getItem('mapCenter').split(',') : [118.047928, 24.613341];
  },
  methods: {
    onselectNet: function onselectNet() {
      var _this = this;

      this.netSelectindex = !this.netSelectindex;
      if (this.plugin[0].showRoad) this.plugin[0].showRoad = false;else this.plugin[0].showRoad = true;
      this.mapControlindex = 1;
      this.window = null;
      this.$nextTick(function () {
        _this.changeVisible();

        _this.mapControlindex = 0;
      });
    },
    onselectRoad: function onselectRoad() {
      var _this2 = this;

      this.roadSelectindex = !this.roadSelectindex; // this.$forceUpdate()
      // let a = this.$refs.maps.$$getInstance()

      if (this.plugin[0].showTraffic) this.plugin[0].showTraffic = false;else this.plugin[0].showTraffic = true;
      this.mapControlindex = 1;
      this.window = null;
      this.$nextTick(function () {
        _this2.changeVisible();

        _this2.mapControlindex = 0;
      });
    },
    onselectMap: function onselectMap(index) {
      this.mapSelectindex = !this.mapSelectindex;
      this.changeMap(); // if(index)this.plugin[0].defaultType = 1
      // else this.plugin[0].defaultType = 1
    },
    changeMap: function changeMap() {
      var _this3 = this;

      if (this.plugin[0].defaultType) this.plugin[0].defaultType = 0;else this.plugin[0].defaultType = 1;
      this.mapControlindex = 1;
      this.window = null;
      this.$nextTick(function () {
        _this3.changeVisible();

        _this3.mapControlindex = 0;
      }); // this.$refs.map.$forceUpdate()
      // this.$forceUpdate()
    },
    changeVisible: function changeVisible() {
      var _this4 = this;

      var arr = [];
      var stand = {};
      var windows = [];
      var arr2 = [];
      var that = this;
      that.markerList.forEach(function (item, index) {
        // that.standardList.forEach((item1, index1) => {
        //   if (item1.data.id == item.standardOptionId) {
        //     stand = item1.data
        //   }
        // })
        // item.stand = stand
        // stand = {}
        var position;
        if (item.longitude != 'NaN') position = [item.longitude, item.latitude];else position = _this4.center; // arr.push(item.longitude)
        // arr.push(item.latitude)

        item.position = position;
        item.show = true;

        if (item.currentStandard) {
          if (item.st == '21') {
            item.content = that.getCir(item.currentStandard.color, item.currentStandard.title.replace('类', ''), item.warnStatus, item.onlineStatus, item.name);
          } else if (item.st == '22') {
            item.content = that.getRec(item.currentStandard.color, item.currentStandard.title, item.warnStatus, item.onlineStatus, item.name);
          }
        } else {
          item.content = that.getnoneRec('#ccc', item.name, item.warnStatus, item.onlineStatus);
        }

        ;
        item.events = {
          click: function click() {
            that.windows.forEach(function (window) {
              window.visible = false; //关闭窗体
            });
            that.selectType = item.st;
            that.window = that.windows[index];
            that.$nextTick(function () {
              // this.mainRealtime(item.id)
              that.window.visible = true; //点击点坐标，出现信息窗体

              that.getsiteDetail(item.id); //获取对应id的站点详情

              that.getStandardList(item.st, item.id);
              that.getDateLists(item.id, item.st); // that.getSkyList(item.id)
              // that.getSiteInfo(item.id)
              // that.queryOnlineById(item.id)
              // that.loadData(item.id)
            });
          }
        }, arr = [];
        var positions;
        if (item.longitude != 'NaN') positions = [item.longitude, item.latitude];else positions = that.center;
        windows.push({
          position: positions,
          offset: [10, -30],
          //窗体偏移
          visible: false,
          //初始是否显示
          name: item.name,
          onlineStatus: item.onlineStatus,
          siteId: item.id
        });
      }); //加弹窗

      that.windows = windows;
    },
    ontoSite: function ontoSite() {
      var _this5 = this;

      sessionStorage.setItem('selectId', JSON.stringify(this.siteDetail)); // sessionStorage.setItem('selectIndex', 3)

      setTimeout(function () {
        // debugger
        _this5.$router.push({
          path: '/ds/index',
          query: {
            tab: 5
          }
        });
      }, 1000);
    },
    getStand: function getStand(data) {
      if (data) {
        for (var i = 0; i < this.standardList.length; i++) {
          if (this.standardList[i].data.title == data.title.replace('类', '')) {
            return i + 1;
          }
        }
      } else {
        return 0;
      }
    },
    onShowleft: function onShowleft() {
      var _this6 = this;

      this.showLeft = !this.showLeft;
      setTimeout(function () {
        _this6.showDrawer = !_this6.showDrawer;
      }, 500);
    },
    // 点击地图下对应的图标
    Ontoselectwater: function Ontoselectwater(index, index1, obj) {
      this.standList[index].children[index1].statu = !this.standList[index].children[index1].statu;
      this.markerList.forEach(function (item, index) {
        if (item.currentStandard) {
          if (item.currentStandard.title == obj.data.title && item.currentStandard.id == obj.data.id) {
            item.show = !item.show;
          }

          return item;
        }
      }); // for (let i = 0; i < this.markerList.length; i++) {
      //   if (this.markerList[i].st == st && this.markerList[i].id == id) {
      //     this.markerList[i].show = !this.markerList[i].show
      //   }
      // }
      // }
      // this.markers = this.markers.splice(1)
    },
    // 获取实时水质标准
    getwaterStand: function getwaterStand(id) {
      var _this7 = this;

      if (this.selectType == 21) {
        queryStand('id=' + id).then(function (res) {
          if (res.success) {
            var date = [];
            var color = [];
            var title = [];
            var a = [];
            a.push(_this7.getStand(res.result['同比标准'][Object.keys(res.result['同比标准'])[0]]));
            a.push(_this7.getStand(res.result['实时标准'][Object.keys(res.result['实时标准'])[0]]));
            a.push(_this7.getStand(res.result['环比标准'][Object.keys(res.result['环比标准'])[0]]));
            date.push(Object.keys(res.result['同比标准'])[0]);
            date.push(Object.keys(res.result['实时标准'])[0]);
            date.push(Object.keys(res.result['环比标准'])[0]);

            if (res.result['同比标准'][Object.keys(res.result['同比标准'])[0]] != null) {
              color.push(res.result['同比标准'][Object.keys(res.result['同比标准'])[0]].color);
              title.push(res.result['同比标准'][Object.keys(res.result['同比标准'])[0]].title);
            } else {
              color.push('');
              title.push('');
            }

            if (res.result['实时标准'][Object.keys(res.result['实时标准'])[0]] != null) {
              color.push(res.result['实时标准'][Object.keys(res.result['实时标准'])[0]].color);
              title.push(res.result['实时标准'][Object.keys(res.result['实时标准'])[0]].title);
            } else {
              color.push('');
              title.push('');
            }

            if (res.result['环比标准'][Object.keys(res.result['环比标准'])[0]]) {
              color.push(res.result['环比标准'][Object.keys(res.result['环比标准'])[0]].color);
              title.push(res.result['环比标准'][Object.keys(res.result['环比标准'])[0]].title);
            } else {
              color.push('');
              title.push('');
            }

            _this7.$refs.dials.initBarChart(title, color, date, a, _this7.standardList.length); // let arr = []
            // let color = []
            // if(res.result['同比标准']){
            // 	color.push()
            // }
            // color.push()

          } else {
            _this7.showDial = true;

            var _date = new Date();

            var year1 = _date.getFullYear() - 1 + '-' + (_date.getMonth() + 1) + '-' + _date.getDate();

            var year2 = _date.getFullYear() + '-' + (_date.getMonth() + 1) + '-' + _date.getDate();

            var year3 = _date.getFullYear() + '-' + _date.getMonth() + '-' + _date.getDate();

            _this7.$nextTick(function () {
              _this7.$refs.dials.initBarChart(['', '', ''], ['#ccc', '#ccc', '#ccc'], [year1, year2, year3], [0, 0, 0], 6);
            });
          }
        });
      } else if (this.selectType == 22) {
        querySkyStandBySite('id=' + id).then(function (res) {
          if (res.success && res.result) {
            _this7.$refs.plate.initBarChart(res.result['excellent']);

            _this7.$refs.doublePlate.initBarChart(res.result['PM25'], res.result['pollution']);
          } else {
            _this7.$refs.plate.initBarChart({
              someNum: 0,
              nowNum: 0
            });

            _this7.$refs.doublePlate.initBarChart({
              someNum: 0,
              nowNum: 0
            }, {
              someNum: 0,
              nowNum: 0
            });
          }
        });
      }
    },
    // 获取国标数据
    getStandard: function getStandard(st) {
      var _this8 = this;

      queryStandardTreeList().then(function (res) {
        if (res.success) {
          var arr = [];
          res.result.forEach(function (item, index) {
            if (item.label == '国家标准') {
              arr = item.children;
            }
          });

          if (arr != null) {
            arr.forEach(function (item, index) {
              if (item.children != null) {
                item.children.forEach(function (item1, index1) {
                  item1.statu = true;
                  item1.title = item1.title.replace('类', '');

                  if (item.key == 'K1_3') {
                    item1.class = 'map-tag-cir';
                  } else if (item.key == 'K1_2') {
                    item1.class = 'map-tag-rec';
                  }

                  return item1;
                });
              }

              return item;
            });
          }

          _this8.standList = arr;
        }
      });
    },
    // 获取国标数据
    getStandardList: function getStandardList(st, id) {
      var _this9 = this;

      queryStandardTreeList().then(function (res) {
        if (res.success) {
          var arr = [];

          if (st == '21') {
            res.result.forEach(function (item, index) {
              if (item.label == '国家标准') {
                if (item.children != null) {
                  item.children.forEach(function (item1, index1) {
                    if (item1.key == 'K1_3') {
                      arr = item1.children;
                    }
                  });
                }
              }
            });
          } else {
            res.result.forEach(function (item, index) {
              if (item.label == '国家标准') {
                if (item.children != null) {
                  item.children.forEach(function (item1, index1) {
                    if (item1.key == 'K1_2') {
                      arr = item1.children;
                    }
                  });
                }
              }
            });
          }

          arr.forEach(function (item, index) {
            item.data.title = item.data.title.replace('类', '');
            item.data.show = true;
            return item;
          });
          _this9.standardList = arr;

          _this9.getwaterStand(id); //获取当前水质标准

        }
      });
    },
    querySiteList: function querySiteList(id) {
      var _this10 = this;

      var that = this; // 污水站点

      _querySiteList({
        id: id
      }).then(function (res) {
        if (res) {
          if (id == '8') {
            _this10.remark = res.result.records[0].remarkll;
            _this10.imgSrc = location.origin + '/env/sys/common/file/view/' + res.result.records[0].photo;
          } else if (id == '12') {
            _this10.remark2 = res.result.records[0].remark;
            _this10.imgSrc2 = location.origin + '/env/sys/common/file/view/' + res.result.records[0].photo;
          } else if (id == '7') {
            _this10.remark3 = res.result.records[0].remark;
            _this10.imgSrc3 = location.origin + '/env/sys/common/file/view/' + res.result.records[0].photo;
          } else if (id == '10') {
            _this10.remark = res.result.records[0].remark;
            _this10.imgSrc4 = location.origin + '/env/sys/common/file/view/' + res.result.records[0].photo;
          } else if (id == '9') {
            _this10.remark5 = res.result.records[0].remark;
            _this10.imgSrc5 = location.origin + '/env/sys/common/file/view/' + res.result.records[0].photo;
          } else if (id == '11') {
            _this10.remark6 = res.result.records[0].remark;
            _this10.imgSrc6 = location.origin + '/env/sys/common/file/view/' + res.result.records[0].photo;
          }
        }
      });
    },
    mainRealtime: function mainRealtime(id) {
      var _this11 = this;

      var that = this;
      this.columns = [];

      _mainRealtime({
        siteId: id
      }).then(function (res) {
        res.result.factorMap.all.forEach(function (e, i) {
          _this11.columns.push({
            title: e.title,
            align: 'center',
            width: '100px',
            dataIndex: e.code,
            customRender: function customRender(text, record, index) {
              return that.renderCol(e.code, text, record);
            }
          });
        });
        _this11.dataSource = res.result.records;
      });
    },
    queryOnlineById: function (_queryOnlineById) {
      function queryOnlineById(_x) {
        return _queryOnlineById.apply(this, arguments);
      }

      queryOnlineById.toString = function () {
        return _queryOnlineById.toString();
      };

      return queryOnlineById;
    }(function (id) {
      var that = this;
      queryOnlineById(id).then(function (res) {
        if (res.success) {
          that.online = res.code;
        }
      });
    }),
    loadData: function loadData(id) {
      var that = this;
      var params = {
        siteId: id
      }; //查询条件

      this.loading = true;
      that.dataSource = [];
      getAction(this.url.list, params).then(function (res) {
        if (res.success) {
          if (res.result) {
            var obj = res.result.data;
            that.inletStatus = res.result.inletStatus;
            that.outletStatus = res.result.outletStatus;
            that.dataSource = [{
              name: 'COD',
              inValue: obj.e102.value,
              inStatus: obj.e102.status,
              outValue: obj.e202.value,
              outStatus: obj.e202.status,
              unit: 'mg/L'
            }, {
              name: '氨氮',
              inValue: obj.e103.value,
              inStatus: obj.e103.status,
              outValue: obj.e203.value,
              outStatus: obj.e203.status,
              unit: 'mg/L'
            }, {
              name: '总磷',
              inValue: obj.e104.value,
              inStatus: obj.e104.status,
              outValue: obj.e204.value,
              outStatus: obj.e204.status,
              unit: 'mg/L'
            }, {
              name: '总氮',
              inValue: obj.e105.value,
              inStatus: obj.e105.status,
              outValue: obj.e232.value,
              outStatus: obj.e232.status,
              unit: 'mg/L'
            }, {
              name: 'PH',
              inValue: obj.e106.value,
              inStatus: obj.e106.status,
              outValue: obj.e205.value,
              outStatus: obj.e205.status,
              unit: '一'
            }, {
              name: 'SS',
              inValue: obj.e130.value,
              inStatus: obj.e130.status,
              outValue: obj.e230.value,
              outStatus: obj.e230.status,
              unit: 'mg/L'
            }, {
              name: '温度',
              inValue: obj.e131.value,
              inStatus: obj.e131.status,
              outValue: obj.e231.value,
              outStatus: obj.e231.status,
              unit: '℃'
            }, {
              name: '瞬时流量',
              inValue: obj.e132.value,
              inStatus: obj.e132.status,
              outValue: obj.e233.value,
              outStatus: obj.e233.status,
              unit: 'L/s'
            }, {
              name: '总流量',
              inValue: obj.e101.value,
              inStatus: obj.e101.status,
              outValue: obj.e201.value,
              outStatus: obj.e201.status,
              unit: 'm³'
            }];
          }
        } else {
          that.$message.warning('系统异常=>' + res.message);
        }

        that.loading = false;
      });
    },
    // 获取到圆
    getCir: function getCir(bgColor, name, warnState, onlineState, siteName) {
      var warnStyle = '';
      var onlineStyle = '';

      if (warnState) {
        warnStyle = '<img style=\'width:30px;height:30px;position:absolute;right:-30px;\' src=\'' + imgUrl + '\' />';
      }

      if (!onlineState) {
        onlineStyle = '<div class=\'iconfont icon-dacha\' style=\'font-size:27px;position:absolute;left:4px;top:0;color:#000;font-weight:400;\'></div>';
      }

      return '<div style=\'position:relative;width: 35px;height: 35px;border-radius: 50%;font-size: 10px;background-color:' + bgColor + ';color: #fff;text-align: center;line-height: 35px;cursor: pointer;\'' + 'title=\'' + siteName + '\'>' + name + warnStyle + onlineStyle + '</div>';
    },
    // 未获取到当前标准
    getnoneRec: function getnoneRec(bgColor, name, warnState, onlineState) {
      var warnStyle = '';
      var onlineStyle = '';

      if (warnState) {
        warnStyle = '<img style=\'position:absolute;right:-50px;top:10px;width:30px;height:30px;\' src=\'' + imgUrl + '\' />';
      }

      if (!onlineState) {
        onlineStyle = '<div class=\'iconfont icon-dacha\' style=\'font-size:27px;position:absolute;top:0;color:#000;font-weight:400;margin-left:-13px\'></div>';
      }

      return '<div style=\'position:relative;width: 0;height: 0;font-size:16px;line-height:58px;border-left: 20px solid transparent;border-right: 20px solid transparent;border-bottom: 40px solid ' + bgColor + '\';color: #fff;text-align: center;line-height: 35px;cursor: pointer;display:flex;justify-content:center;\'' + ' title=\'' + name + '\'><span style=\'margin-left:-7px\'>' + // name +
      '无</span>' + warnStyle + onlineStyle + '</div>';
    },
    // 获取到正方形
    getRec: function getRec(bgColor, name, warnState, onlineState, siteName) {
      var warnStyle = '';
      var onlineStyle = '';

      if (warnState) {
        warnStyle = '<img style=\'width:30px;height:30px;position:absolute;right:-30px;\' src=\'' + imgUrl + '\' />';
      }

      if (!onlineState) {
        onlineStyle = '<div class=\'iconfont icon-dacha\' style=\'font-size:27px;position:absolute;left:4px;top:0;color:#000;font-weight:400;\'></div>';
      }

      return '<div style=\'position:relative;width: 35px;height: 35px;font-size: 10px;background-color:' + bgColor + ';color: #fff;text-align: center;line-height: 35px;cursor: pointer;\'' + 'title=\'' + siteName + '\'>' + name + warnStyle + onlineStyle + '</div>';
    },
    // 获取站点数据
    getSite: function getSite(st) {
      var _this12 = this;

      var that = this;
      querySiteBySt({
        st: st
      }).then(function (res) {
        if (res.success) {
          var arr = [];
          var stand = {};
          var windows = [];
          var arr2 = [];
          res.result.forEach(function (item, index) {
            // that.standardList.forEach((item1, index1) => {
            //   if (item1.data.id == item.standardOptionId) {
            //     stand = item1.data
            //   }
            // })
            // item.stand = stand
            // stand = {}
            if (item.latitude != 'NaN') item.position = [item.longitude, item.latitude];else item.position = _this12.center;
            item.show = true;

            if (item.currentStandard) {
              if (item.st == '21' || item.st == '32') {
                item.content = that.getCir(item.currentStandard.color, item.currentStandard.title.replace('类', ''), item.warnStatus, item.onlineStatus, item.name);
              } else if (item.st == '21' || item.st == '31') {
                item.content = that.getRec(item.currentStandard.color, item.currentStandard.title, item.warnStatus, item.onlineStatus, item.name);
              }
            } else {
              item.content = that.getnoneRec('#ccc', item.name, item.warnStatus, item.onlineStatus);
            }

            ;
            item.events = {
              click: function click() {
                that.windows.forEach(function (window) {
                  window.visible = false; //关闭窗体
                });
                that.selectType = item.st;
                that.window = that.windows[index];
                that.$nextTick(function () {
                  // this.mainRealtime(item.id)
                  that.window.visible = true; //点击点坐标，出现信息窗体

                  that.getsiteDetail(item.id); //获取对应id的站点详情

                  that.getStandardList(item.st, item.id);
                  that.getDateLists(item.id, item.st); // that.getSkyList(item.id)
                  // that.getSiteInfo(item.id)
                  // that.queryOnlineById(item.id)
                  // that.loadData(item.id)
                });
              }
            }, arr = [];
            var positions;
            if (item.longitude != 'NaN') positions = [item.longitude, item.latitude];else positions = that.center;
            windows.push({
              position: positions,
              offset: [10, -30],
              //窗体偏移
              visible: false,
              //初始是否显示
              name: item.name,
              onlineStatus: item.onlineStatus,
              siteId: item.id
            });
          }); //加弹窗

          that.windows = windows;
          that.markerList = res.result;
        }
      });
    },
    // 渲染列
    renderCols: function renderCols(code, text, record) {
      var data = record.dataCodeMap[code] || {
        value: ''
      };

      if (data.status == '2') {
        return "<span  style='color:green;padding-left:15px' class='redText' title='原始数据：  " + data.raw + "'>" + data.value + "<div class='iconfont icon-xiangxiajiantou' style='float:right;color:green' ></div></span>";
      } else if (data.status == '3') {
        return "<span style='color:red;padding-left:15px' title='原始数据：" + data.raw + "'>" + data.value + "<div class='iconfont icon-iconset0414' style='float:right;color:red' ></div></span>";
      } else {
        return "<span title='原始数据：" + data.raw + "'>" + data.value + '</span>';
      }
    },
    // 渲染列
    renderCol: function renderCol(code, text, record) {
      var h = this.$createElement;
      var data = record.dataMap[code] || {
        value: ''
      };

      if (data.status == '2') {
        return h("span", {
          "class": "redText",
          "attrs": {
            "title": '原始数据： ' + data.raw
          }
        }, [data.value, h("a-icon", {
          "attrs": {
            "type": "arrow-down"
          },
          "style": "float:right"
        })]);
      } else if (data.status == '3') {
        return h("span", {
          "class": "redText",
          "attrs": {
            "title": '原始数据： ' + data.raw
          }
        }, [data.value, h("a-icon", {
          "attrs": {
            "type": "arrow-up"
          },
          "style": "float:right"
        })]);
      } else {
        return h("span", {
          "attrs": {
            "title": '原始数据： ' + data.raw
          }
        }, [data.value]);
      }
    },
    getStatus: function getStatus(value) {
      var h = this.$createElement;
      var status = '';

      switch (value) {
        case 1:
          status = '达标';
          break;

        case 2:
          status = h("a-icon", {
            "attrs": {
              "type": "arrow-down"
            }
          });
          break;

        case 3:
          status = h("a-icon", {
            "attrs": {
              "type": "arrow-up"
            }
          });
          break;
      }

      return status;
    },
    // 获取站点数据
    getDateLists: function getDateLists(id, st) {
      var _this13 = this;

      if (st == 21) {
        queryDateList({
          size: 10000000,
          current: 1,
          id: id,
          type: 1
        }).then(function (res) {
          if (res.success) {
            var state;
            res.result.factors.forEach(function (item, index) {
              item.value = res.result.records[0].dataCodeMap[item.code].value;
              item.standTitle = res.result.records[0].dataCodeMap[item.code].standard.title;
              item.standColor = res.result.records[0].dataCodeMap[item.code].standard.color;

              switch (res.result.records[0].dataCodeMap[item.code].status) {
                case 0:
                  state = '无数据';
                  break;

                case 1:
                  state = '正常';
                  break;

                case 2:
                  state = '下表越界';
                  break;

                case 3:
                  state = '高报';
                  break;

                case 4:
                  state = '数据异常';
                  break;
              }

              item.state = state;
              item.render = _this13.renderCols(item.code, '', res.result.records[0]);
              state = '';
              return item;
            });

            if (res.result.records.length > 0) {
              _this13.standState = res.result.records[0].upStandard;
              _this13.standLabel = res.result.records[0].upStandard ? '达标' : '不达标';
              _this13.standText = res.result.records[0].currentStandard.title;
            } else {
              _this13.standState = false;
              _this13.standLabel = '不达标';
              _this13.standText = '';
            } // let arr = []
            // for(let i =0;i<6;i++){
            // 	res.result.factors.forEach((item)=>{
            // 		arr.push(item)
            // 	})
            // }
            // this.dateLists = arr


            setTimeout(function () {
              _this13.dateLists = res.result.factors;
            }, 1000);
          }
        });
      } else if (st == 22) {
        queryDateSkylist({
          size: 10000000,
          current: 1,
          id: id,
          type: 1,
          factorGroup: 'airTeams'
        }).then(function (res) {
          if (res.success && res.result.records.length > 0) {
            _this13.firstPollution = res.result.records[0].pollutions[0];

            _this13.$refs.instrument.initBarChart(res.result.records[0].aqi, res.result.records[0].currentStandard.title, res.result.records[0].currentStandard.color);

            if (res.result) {
              var obj = {};
              var arr = [];
              var title = [];
              res.result.factors.forEach(function (item, index) {
                if (item.alias == 'AQI') return;
                arr.push(res.result.records[0].dataCodeMap[item.code].value);
                title.push(item.alias);
              });

              _this13.$refs.bartype.initBarChart(arr, title); // this.$refs.schedule.initBarChart(arr)

            } // this.$refs.schedule.initBarChart()

          } else {
            _this13.$refs.instrument.initBarChart(0, '无', '#fff');

            _this13.$refs.bartype.initBarChart([], []);
          }
        });
      }
    },
    getImageView: function getImageView(photo) {
      return this.url.imgerver + '/' + photo;
    },
    // 获取对应站点详情
    getsiteDetail: function getsiteDetail(id) {
      var _this14 = this;

      queryBigDataById({
        id: id
      }).then(function (res) {
        if (res.success) {
          res.result.photo = _this14.getImageView(res.result.photo);
          _this14.siteDetail = res.result;
        }
      });
    },
    getSiteInfo: function getSiteInfo(id) {
      var that = this;
      var params = {
        id: id
      };
      querySiteById(params).then(function (res) {
        if (res.success) {
          that.siteInfo = res.result;
        }
      });
    },
    positionSite: function positionSite(id) {
      var _this15 = this;

      this.markerList.forEach(function (v, i) {
        if (v.id == id) {
          _this15.center = v.position;
          _this15.zoom = 14;
        }
      });
    }
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();

      if (ids[0] && ids[0] == 1) {
        // 根据站点id
        this.positionSite(ids[1]);
      } else {// 根据区域id
        // if (ids[1] == 57) {
        //   //是否选择了雅安市
        //   this.center = [103.003398, 29.981831]
        //   this.zoom = 9
        // } else {
        // }
      }
    }
  }
};